/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';
import wareTrans from './warehouse';

export default class ProductWarehouseTransformer extends Transformer {

  static fetch(transaction) {
    return {
      id: transaction.id,
      warehouseId: transaction.warehouse_id,
      productId: transaction.product_id,
      batchId: transaction.batch_id,
      minimum_stock_level: transaction.minimum_stock_level,
      warehouse: transaction.warehouse !== undefined ? wareTrans.fetch(transaction.warehouse) : [],
      qty: transaction.qty,
      qtyNumber: transaction.qty_number,
      currentQty: transaction.current_qty,
      batchName: transaction.batch_name,
      totalItemQty: transaction.total_item_qty,
      totalCrateQty: transaction.total_crate_qty,
      totalLooseQty: transaction.total_loose_qty,
    };
  }

  static send(transaction) {
    return {
      id: transaction.id,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productWarehouse.js